import GisMap from './gis-map/index.vue';
import mapData from './data';
import Service from '@/service/index.js';

export default {
  components: {
    GisMap
  },
  data: () => {
    return {
      positions: [],
      defaultImage: '',
      item: null,
      mapWidth: '',
      showGis: false,
      code: '34',
      level: '1'
    };
  },
  computed: {
  },

  created() {
    // this.getAreaInfoByName();
    // this.getDefaultArea();
  },
  methods: {
    getAreaInfoByName () {
      const hostList = window.location.host.split('.');
      let name = hostList[0];
      if (hostList[0] === 'www') {
        name = hostList[1];
      }
      name = 'jilin';
      Service.getAreaInfoByName(name).then(({ code, data, reason }) => {
        if (code === '0') {
          this.code = data.areaCode;
          this.showGis = true;
        } else {
          this.$errorMessage(reason);
        }
      });
    },
    getNameByAreaCode (areaCode) {
      Service.getNameByAreaCode(areaCode).then(({ code, data, reason }) => {
        if (code === '0') {
          this.toTargetPageView(data);
        } else {
          this.$errorMessage(reason);
        }
      });
    },
    mapClick (info) {
      const areaCode = info.PAC.substr(0, 9);
      this.getNameByAreaCode(areaCode);
    },
    toTargetPageView(url) {
      if (window.location.origin.indexOf('dev') >= 0 || window.location.origin.indexOf('http://localhost') >= 0 || window.location.origin.indexOf('test') >= 0 || window.location.origin.indexOf('jlncjy.cn') >= 0 || window.location.origin.indexOf('stage') >= 0) {
        window.open('http://www.' + url + '.jlncjy.cn/');
        // window.open('http://www.' + url + '.jlncjy.com/');
      } else {
        window.open('http://' + url + '.jlncjy.com/');
      }
    },
    style(item) {
      let style = {
        width: item.width + 'px',
        height: item.height + 'px'
      };
      if (item.top) {
        style.top = item.top + 'px';
      }
      if (item.bottom) {
        style.bottom = item.bottom + 'px';
      }
      if (item.right) {
        style.right = item.right + 'px';
      }
      if (item.left) {
        style.left = item.left + 'px';
      }
      return style;
    },

    imageStyle() {
      let style = {};
      console.log(this.mapWidth);
      if (this.mapWidth) {
        return {
          width: this.mapWidth + 'px',
          'margin-left': (360 - this.mapWidth) / 2 + 'px'
        };
      }
      return style;
    },

    getDefaultArea() {
      // let url = location.protocol + '//' + location.host;
      let url = window.location.href;
      const target = this.getCurrentArea(mapData, url);
      if (!target || !target.images) {
        this.defaultImage = 'home/map.png';
        this.positions = mapData;
      } else {
        this.defaultImage = target.images;
        this.positions = target.positions;
        this.mapWidth = target.mapWidth;
      }
    },

    getCurrentArea(arr, url) {
      if (!arr) { return; }
      arr.forEach(item => {
        if (url.indexOf(item.url) >= 0 && !this.item) {
          this.item = item;
          return;
        }
        if (!this.item) {
          this.getCurrentArea(item.positions, url);
        }
      });
      return this.item;
    }
  }
};
